<div class="d-flex align-items-center justify-content-center mb-0">
  <!-- Short Logo -->
  <div class="sidebar-brand-logo rounded-3"></div>

</div>
